<template>
    <v-container fluid>
        <v-snackbar v-model="showToast" color="red lighten-1" text top right rounded style="margin-top: 75px">
            {{ toastMsg }}
            <template v-slot:action="{ attrs }">
                <v-btn color="red lighten-1" text v-bind="attrs" @click="showToast = false">
                    <v-icon color="red lighten-1">
                        close
                    </v-icon>
                </v-btn>
            </template>
        </v-snackbar>
        <v-row>
            <v-col>
                <v-toolbar id="billing-rate-toolbar" flat>
                    <v-row>
                        <v-col cols="6">
                            <v-toolbar-title> Billing Rate Periods </v-toolbar-title>
                        </v-col>
                        <v-col cols="6" class="text-right">
                            <AddBillingRatePeriod model-type="Add" />
                        </v-col>
                    </v-row>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row class="mt-0" :no-gutters="this.$vuetify.breakpoint.xs">
            <v-col>
                <v-data-table 
                    id="billing-rate-period-table" 
                    item-key="rowid" 
                    :headers="headers"
                    :items="companyBillingRatePeriods" 
                    fixed-header 
                    hide-default-footer 
                    dense
                    :items-per-page="-1"
                    :disable-pagination="true"
                >
                    <template v-slot:[`item.code`]="{ item }">
                        {{ item.code }}
                    </template>
                    <template v-slot:[`item.time_from`]="{ item }">
                        {{ item.time_from }}
                    </template>
                    <template v-slot:[`item.time_to`]="{ item }">
                        {{ item.time_to }}
                    </template>
                    <template v-slot:[`item.edit`]="{ item }">
                        <AddBillingRatePeriod :billing-rate-periods-details="item" model-type="Edit" />
                    </template>
                    <template v-slot:[`item.delete`]="{ item }">
                        <DeleteBillingRatePeriod :billing-rate-periods-details="item" model-type="Delete" />
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import AddBillingRatePeriod from './AddBillingRatePeriod';
import DeleteBillingRatePeriod from './DeleteBillingRatePeriod';

export default {
    components: {
        AddBillingRatePeriod,
        DeleteBillingRatePeriod,
    },
    data: () => ({
        showToast: false,
        toastMsg: '',
        headers: [
            {
                text: 'Billing Rate Period',
                align: 'left',
                sortable: true,
                value: 'code',
            },
            {
                text: 'Time From',
                align: 'left',
                sortable: true,
                value: 'time_from',
            },
            {
                text: 'Time To',
                align: 'left',
                sortable: true,
                value: 'time_to',
            },
            {
                text: 'Edit',
                value: 'edit',
                sortable: false
            },
            {
                text: 'Delete',
                value: 'delete',
                sortable: false
            },
        ],
    }),
    computed: {
        companyBillingRatePeriods() {
            return this.$store.getters.companyBillingRatePeriods.rate_periods;
        },
    },
    async mounted() {
        await this.$store.dispatch('getCompanyBillingRatePeriods');
    },
};
</script>
<style scoped>
.mobile-billing-rate-periods-action-bar {
    position: fixed;
    bottom: 0px;
    width: 100%;
    text-align: center;
}

.mobile-billing-rate-periods-action-bar .v-btn {
    width: 170px;
}

.table-header {
    background-color: #a72251;
}
</style>
